export default {
    alert_details_edit: "Editar",
    alert_details_device_model: "Modelo de dispositivo",
    alert_details_manufacturer: "Fabricante",
    alert_details_save: "Guardar",
    alert_details_edit_Assignments: "Editar asignaciones",
    alert_details_edit_alert_type: "Editar tipo de alerta",
    alert_details_edit_alert_type_success: "Se ha editado el tipo de alerta",
    alert_details_edit_alert_type_error: "El tipo de alerta no se ha editado",
    alert_details_edit_alert_type_warning: "El modelo de dispositivo ya está en la lista",
    alert_details_units_supporting: "Modelos de dispositivos que admiten este tipo de alerta",
    alert_details_no_data: "Sin Modelos de dispositivos",
    alert_details_placeholder: "Buscar por modelo de dispositivo o fabricante",
    alert_details_confirm_delete: "Si cancelas se borrarán los cambios realizados, ¿quieres continuar?",
    alert_details_add_back: "Agregar de nuevo",
    alert_details_search_device_model: "Buscar por modelo de dispositivo",
}